<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div class="record-content tabs-layout container-fluid pl-0 pr-0 pt-0 record-content-skeleton">
    <ul class="nav-tabs nav">
        <li class="tab nav-item">
            <a class="tab-link nav-link active pl-5 pr-5 h-100 box-loading" href="">
            </a>
        </li>
        <li class="tab nav-item">
            <a class="tab-link nav-link pl-5 pr-5 h-100 box-loading" href="">
            </a>
        </li>
        <li class="tab nav-item">
            <a class="tab-link nav-link pl-5 pr-5 h-100 box-loading" href="">
            </a>
        </li>
    </ul>
    <div class="p-2 pt-3 rounded-right rounded-bottom tab-content">
        <div class="tab-pane fade active show">
            <div class="">
                <form class="detail field-layout">


                    <div class="field-layout-row form-row mb-1 align-items-stretch ng-star-inserted">
                        <div class="field-layout-col field-column-bordered col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                        <div class="field-layout-col col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                    </div>
                    <div class="field-layout-row form-row mb-1 align-items-stretch ng-star-inserted">
                        <div class="field-layout-col field-column-bordered col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                        <div class="field-layout-col col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                    </div>
                    <div class="field-layout-row form-row mb-1 align-items-stretch ng-star-inserted">
                        <div class="field-layout-col field-column-bordered col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                        <div class="field-layout-col col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                    </div>
                    <div class="field-layout-row form-row mb-1 align-items-stretch ng-star-inserted">
                        <div class="field-layout-col field-column-bordered col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                        <div class="field-layout-col col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                    </div>
                    <div class="field-layout-row form-row mb-1 align-items-stretch ng-star-inserted">
                        <div class="field-layout-col field-column-bordered col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                        <div class="field-layout-col col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                    </div>
                    <div class="field-layout-row form-row mb-1 align-items-stretch ng-star-inserted">
                        <div class="field-layout-col field-column-bordered col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                        <div class="field-layout-col col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                    </div>
                    <div class="field-layout-row form-row mb-1 align-items-stretch ng-star-inserted">
                        <div class="field-layout-col field-column-bordered col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                        <div class="field-layout-col col form-group m-0 pl-3 pb-2 pr-3 d-flex flex-column justify-content-between ng-star-inserted">
                            <div class="field-layout-field-group-wrapper form-group row ng-star-inserted">
                                <div class="col-form-label col-sm-3 field-layout-field-label-wrapper label-container">
                                    <strong>
                                        <label class="col-form-label-sm mb-0 pb-3 pl-5 pr-5 h-100 rounded box-loading">
                                        </label>
                                    </strong>
                                </div>
                                <div class="col-sm-9 d-flex flex-grow-1 field-layout-field-wrapper">
                                    <div class="flex-grow-1 text-break rounded box-loading skeleton-field-content">
                                    </div>
                                    <!-- <div>
                                        <button class="record-action-button" type="button">
                                            <scrm-image image="pencil">
                                            </scrm-image>
                                        </button>
                                    </div> -->
                                </div>
                            </div>
                            <div class="field-separation mt-2 ng-star-inserted"></div>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</div>
